export default "__VITE_ASSET__BCIpSkVM__"